import { Node } from '@xyflow/react';

/** Keep measured nodes visible while React Flow observes their new content size. */
export function preserveNodeMeasurements(nextNodes: Node[], currentNodes: Node[]): Node[] {
    const currentById = new Map(currentNodes.map(node => [node.id, node]));
    return nextNodes.map(node => {
        const current = currentById.get(node.id);
        if (!current || current.type !== node.type || !current.measured) {
            return node;
        }
        return { ...node, measured: current.measured };
    });
}
